import { createAsyncThunk } from '@reduxjs/toolkit'
import doAsync from '../../infrastructure/doAsync'
import { createFilterString } from '../../helpers/createFilterString'
import { REGIONS } from '../../widgets/busyIndicator'

export const fetchTotals = createAsyncThunk(
	'fetch/totals',
	async ({ filters, useCaching, noBusySpinner } = {}, thunkArgs) => {
		const filterQs = createFilterString(filters)
		const fullQs = filterQs ? `?${filterQs}` : ''
		return await doAsync({
			url: `api/reports/totals${fullQs}`,
			useCaching,
			noBusySpinner,
			busyIndicatorName: REGIONS.FETCH_TOTALS,
			errorMessage: 'Unable to load totals. Please try again later.',
			...thunkArgs,
		})
	}
)
export const fetchCommission = createAsyncThunk(
	'fetch/Getcommission',
	async ({ filters, useCaching, noBusySpinner } = {}, thunkArgs) => {
		const filterQs = createFilterString(filters)
		const fullQs = filterQs ? `?${filterQs}` : ''
		return await doAsync({
			url: `api/reports/Commissions${fullQs}`,
			useCaching,
			noBusySpinner,
			busyIndicatorName: REGIONS.FETCH_COMMISSIONS,
			errorMessage: 'Unable to load Commission. Please try again later.',
			...thunkArgs,
		})
	}
)

export const fetchUnengagedUsers = createAsyncThunk(
	'fetch/unengagedUsers',
	async ({ filters, useCaching, noBusySpinner } = {}, thunkArgs) => {
		const filterQs = createFilterString(filters)
		const fullQs = filterQs ? `?${filterQs}` : ''
		return await doAsync({
			url: `api/reports/unengaged-users${fullQs}`,
			useCaching,
			noBusySpinner,
			busyIndicatorName: REGIONS.FETCH_UNENGAGED_USERS,
			errorMessage: 'Unable to load Unengaged users. Please try again later.',
			...thunkArgs,
		})
	}
)

export const fetchChurnedCustomers = createAsyncThunk(
	'fetch/churnedCustomers',
	async ({ filters, useCaching, noBusySpinner } = {}, thunkArgs) => {
		const filterQs = createFilterString(filters)
		const fullQs = filterQs ? `?${filterQs}` : ''
		return await doAsync({
			url: `api/reports/churned-customers${fullQs}`,
			useCaching,
			noBusySpinner,
			busyIndicatorName: REGIONS.FETCH_CHURNED_CUSTOMERS,
			errorMessage: 'Unable to load churned customers. Please try again later.',
			...thunkArgs,
		})
	}
)

export const fetchProductMix = createAsyncThunk(
	'fetch/productMix',
	async ({ filters, useCaching, noBusySpinner } = {}, thunkArgs) => {
		const filterQs = createFilterString(filters)
		const fullQs = filterQs ? `?${filterQs}` : ''
		return await doAsync({
			url: `api/reports/product-mix${fullQs}`,
			useCaching,
			noBusySpinner,
			busyIndicatorName: REGIONS.FETCH_PRODUCT_MIX,
			errorMessage: 'Unable to load product mix data. Please try again later.',
			...thunkArgs,
		})
	}
)

export const fetchdocumentHistoriesEngagementChart = createAsyncThunk(
	'fetch/documentHistoriesEngagements',
	async ({ filters, useCaching, noBusySpinner } = {}, thunkArgs) => {
		const filterQs = createFilterString(filters)
		const fullQs = filterQs ? `?${filterQs}` : ''
		return await doAsync({
			url: `api/reports/documentHistoriesEngagements${fullQs}`,
			useCaching,
			noBusySpinner,
			busyIndicatorName: REGIONS.FETCH_DOCUMENT_HISTORIES_ENGAGEMENT_CHART,
			errorMessage:
				'Unable to load document histories engagements data. Please try again later.',
			...thunkArgs,
		})
	}
)

export const fetchUsersEngagementChart = createAsyncThunk(
	'fetch/usersEngagement',
	async ({ filters, useCaching, noBusySpinner } = {}, thunkArgs) => {
		const filterQs = createFilterString(filters)
		const fullQs = filterQs ? `?${filterQs}` : ''
		return await doAsync({
			url: `api/reports/usersEngagements${fullQs}`,
			useCaching,
			noBusySpinner,
			busyIndicatorName: REGIONS.FETCH_USERS_ENGAGEMENT_CHART,
			errorMessage:
				'Unable to load users engagements data. Please try again later.',
			...thunkArgs,
		})
	}
)

export const fetchDocumentsEngagementChart = createAsyncThunk(
	'fetch/documentsEngagement',
	async ({ filters, useCaching, noBusySpinner } = {}, thunkArgs) => {
		const filterQs = createFilterString(filters)
		const fullQs = filterQs ? `?${filterQs}` : ''
		return await doAsync({
			url: `api/reports/documentsEngagements${fullQs}`,
			useCaching,
			noBusySpinner,
			busyIndicatorName: REGIONS.FETCH_DOCUMENTS_ENGAGEMENT_CHART,
			errorMessage:
				'Unable to load documents engagements data. Please try again later.',
			...thunkArgs,
		})
	}
)

export const fetchTotalsAdditional = createAsyncThunk(
	'fetch/totalsAdditional',
	async ({ filters, useCaching = true, noBusySpinner } = {}, thunkArgs) => {
		const filterQs = createFilterString(filters)
		const fullQs = filterQs ? `?${filterQs}` : ''
		return await doAsync({
			url: `api/reports/totals-additional${fullQs}`,
			useCaching,
			noBusySpinner,
			busyIndicatorName: REGIONS.FETCH_TOTAL_ADDITIONALS,
			errorMessage:
				'Unable to load totalAdditional data. Please try again later.',
			...thunkArgs,
		})
	}
)
export const fetchCommissionsAdditional = createAsyncThunk(
	'fetch/GetcommissionsAdditional',
	async ({ filters, useCaching = true, noBusySpinner } = {}, thunkArgs) => {
		const filterQs = createFilterString(filters)
		const fullQs = filterQs ? `?${filterQs}` : ''
		return await doAsync({
			url: `api/reports/CommissionDetails${fullQs}`,
			useCaching,
			noBusySpinner,
			busyIndicatorName: REGIONS.FETCH_COMMISSION_ADDITIONALS,
			errorMessage:
				'Unable to load commission additional data. Please try again later.',
			...thunkArgs,
		})
	}
)

export const fetchStores = createAsyncThunk(
	'fetch/stores',
	async (accountId, thunkArgs, { useCaching = true, noBusySpinner } = {}) =>
		await doAsync({
			url: `api/reports/stores/${accountId}`,
			useCaching,
			noBusySpinner,
			errorMessage:
				'Unable to load stores for customer. Please try again later.',
			...thunkArgs,
		})
)

export const fetchReportCustomers = createAsyncThunk(
	'fetch/reportCustomers',
	async ({ useCaching = true, noBusySpinner } = {}, thunkArgs) =>
		await doAsync({
			url: 'api/customers',
			useCaching,
			noBusySpinner,
			errorMessage: 'Unable to load customers. Please try again later.',
			...thunkArgs,
		})
)

export const fetchCloudReport = createAsyncThunk(
	'fetch/cloudReport',
	async ({ filters, useCaching = true, noBusySpinner } = {}, thunkArgs) => {
		return doAsync({
			url: `api/reports/CloudAccountsReport`,
			httpMethod: 'post',
			busyIndicatorName: REGIONS.FETCH_CLOUD_REPORT,
			httpConfig: {
				body: JSON.stringify(filters),
			},
			useCaching,
			noBusySpinner,
			errorMessage: 'Unable to fetch report. Please try again later.',
			...thunkArgs,
		})
	}
)

export const exportCloudReport = createAsyncThunk(
	'export/reportCustomers',
	async ({ filters, useCaching = true, noBusySpinner } = {}, thunkArgs) => {
		return doAsync({
			url: `api/reports/ExportCloudReport`,
			httpMethod: 'post',
			httpConfig: {
				body: JSON.stringify(filters),
			},
			busyIndicatorName: REGIONS.EXPORT_CLOUD_REPORT,
			useCaching,
			noBusySpinner,
			allowDownload: true,
			fileName: 'CloudReport',
			errorMessage: 'Unable to export report. Please try again later.',
			...thunkArgs,
		})
	}
)

export const exportCommissionReport = createAsyncThunk(
	'export/commissionReport',
	async ({ filters, useCaching = true, noBusySpinner } = {}, thunkArgs) => {
		return doAsync({
			url: `api/reports/ExportCommissionDetails`,
			httpMethod: 'post',
			httpConfig: {
				body: JSON.stringify(filters),
			},
			busyIndicatorName: REGIONS.EXPORT_COMMISSION_REPORT,
			useCaching,
			noBusySpinner,
			allowDownload: true,
			fileName: 'CommissionReport',
			errorMessage:
				'Unable to export commission report. Please try again later.',
			...thunkArgs,
		})
	}
)

export const getCloudTiers = createAsyncThunk(
	'fetch/getCloudTiers',
	async ({ useCaching = true, noBusySpinner } = {}, thunkArgs) =>
		doAsync({
			url: `api/reports/CloudTiers`,
			useCaching,
			noBusySpinner,
			errorMessage: 'Unable to fetch cloud tiers. Please try again later.',
			...thunkArgs,
		})
)

export const createFastBoundDeltaReport = createAsyncThunk(
	'create/fastBoundDeltaReport',
	async ({ file, dryRun = true, useCaching = false, noBusySpinner } = {}, thunkArgs) => {
		const formData = new FormData()
		formData.append('invoiceFile', file)

		return await doAsync({
			url: `api/reports/CreateFastBoundDeltaReport?dryRun=${dryRun}`,
			httpMethod: 'post',
			httpConfig: {
				body: formData,
			},
			isMultipartFormData: true,
			allowDownload: true,
			fileName: 'fastbound-delta-report',
			useCaching,
			noBusySpinner,
			busyIndicatorName: REGIONS.CREATE_FASTBOUND_DELTA_REPORT,
			errorMessage: 'Unable to create FastBound delta report. Please try again later.',
			...thunkArgs,
		})
	}
)
